import React from 'react';
import QuestionList from '../questions/QuestionList';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import { Redirect, Link } from 'react-router-dom';

function Questions(props) {
  const { questions, auth } = props;
  if (!auth.uid) return <Redirect to="/signin" />;

  if (questions) {
    return (
      <div className="container">
        <div className="row">
          <QuestionList questions={questions} />
        </div>
        <Link className="btn-floating btn-large fixed-action-btn green right" to="newQuestion">
          <i className="material-icons">add</i>
        </Link>
      </div>
    );
  } else {
    return <div></div>;
  }
}

const mapStateToProps = (state) => {
  return {
    questions: state.firestore.ordered.triviaQuestions,
    auth: state.firebase.auth,
  };
};

export default compose(connect(mapStateToProps), firestoreConnect([{ collection: 'triviaQuestions', orderBy: ['question', 'asc'] }]))(Questions);
